"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserProfileApp = exports.UserProfile = void 0;
var React = require("react");
var stateless_forms_1 = require("../forms/stateless_forms");
var buttons_1 = require("../buttons");
var UserProfileService_1 = require("../../services/UserProfileService");
var generic_1 = require("../generic");
var TwoFactorAuthApp_1 = require("./TwoFactorAuthApp");
var App_1 = require("../../App");
var mobx_react_1 = require("mobx-react");
var UserProfileForm = function (_a) {
    var values = _a.values, profile_svc = _a.profile_svc;
    var fields = [
        {
            name: "first_name",
            label: gettext("First name"),
            field_type: stateless_forms_1.SimpleFormFieldTypes.TEXT,
            value: values.first_name || "",
        },
        {
            name: "last_name",
            label: gettext("Last name"),
            field_type: stateless_forms_1.SimpleFormFieldTypes.TEXT,
            value: values.last_name || "",
        },
        {
            name: "email",
            label: gettext("Email"),
            field_type: stateless_forms_1.SimpleFormFieldTypes.TEXT,
            value: values.email || "",
        },
        {
            name: "telephone",
            label: gettext("Telephone"),
            field_type: stateless_forms_1.SimpleFormFieldTypes.TEXT,
            value: values.telephone || "",
        },
        {
            name: "job_position",
            label: gettext("Position"),
            field_type: stateless_forms_1.SimpleFormFieldTypes.TEXT,
            value: values.job_position || "",
        },
        {
            name: "company",
            label: gettext("Company"),
            field_type: stateless_forms_1.SimpleFormFieldTypes.TEXT,
            value: values.company || "",
        },
        {
            name: "language",
            label: gettext("Language"),
            field_type: stateless_forms_1.SimpleFormFieldTypes.SELECT,
            value: values.language || "",
            options: values.language_options,
        },
        {
            name: "timezone",
            label: gettext("Timezone"),
            field_type: stateless_forms_1.SimpleFormFieldTypes.SELECT,
            value: values.timezone || "",
            options: values.timezone_options,
        },
    ];
    return (React.createElement(stateless_forms_1.SimpleForm, { fields: fields, onUpdate: profile_svc.update, format: {
            form_layout: stateless_forms_1.FormLayout.VERTICAL,
            form_grid_columns: 2,
            form_grid_direction: stateless_forms_1.FormGridDirection.TOP_DOWN,
        }, valuesObject: values }));
};
var UserProfilePicture = function (_a) {
    var values = _a.values, profile_svc = _a.profile_svc;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "profile-picture-image text-center" }, values.picture_url ? (React.createElement("img", { className: "profile-picture-image", src: values.picture_url, alt: "profile-picture" })) : (React.createElement(generic_1.Icon, { name: "user-tie", className: "profile-picture-icon" }))),
        React.createElement(buttons_1.FileUploadButton, { fullWidth: true, caption: gettext("Change Picture"), uploader: profile_svc.set_picture })));
};
var UserProfileChangePassword = function (_a) {
    var values = _a.values, profile_svc = _a.profile_svc;
    var fields = [
        {
            name: "old_password",
            label: gettext("Current password"),
            field_type: stateless_forms_1.SimpleFormFieldTypes.PASSWORD,
            value: values.old_password || "",
        },
        {
            name: "new_password1",
            label: gettext("New password"),
            field_type: stateless_forms_1.SimpleFormFieldTypes.PASSWORD,
            value: values.new_password1 || "",
        },
        {
            name: "new_password2",
            label: gettext("Password confirmation"),
            field_type: stateless_forms_1.SimpleFormFieldTypes.PASSWORD,
            value: values.new_password2 || "",
        },
    ];
    return (React.createElement(stateless_forms_1.SimpleForm, { fields: fields, format: {
            form_layout: stateless_forms_1.FormLayout.HORIZONTAL,
            label_col: 6,
            label_size: stateless_forms_1.FormSize.SMALL,
            input_size: stateless_forms_1.FormSize.SMALL,
        }, onUpdate: profile_svc.update, valuesObject: values }));
};
var UserProfile = function (props) {
    var _a = __read((0, UserProfileService_1.useUserProfileService)(props.user_id), 2), profile_data = _a[0], profile_svc = _a[1];
    React.useEffect(function () {
        profile_svc.retrieve();
    }, [props.user_id]);
    return (React.createElement("div", { className: "container" },
        React.createElement("div", { className: "header" },
            React.createElement("h2", null, gettext("Profile Information"))),
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-3" },
                React.createElement("div", { className: "row text-center" }),
                React.createElement("div", { className: "row mt-3" },
                    React.createElement("div", { className: "col-12" }, profile_data.is_superuser && (React.createElement(generic_1.AlertNote, null, gettext("You are a superuser")))),
                    React.createElement("div", { className: "col-12" }, profile_data.is_staff && (React.createElement(generic_1.AlertNote, null, gettext("You are part of the staff")))),
                    React.createElement("div", { className: "col-12" },
                        React.createElement("h5", null, gettext("Change password")),
                        React.createElement(UserProfileChangePassword, { values: profile_data, profile_svc: profile_svc }),
                        React.createElement(buttons_1.BlockButton, { onClick: function () { return profile_svc.change_password(); } }, gettext("Change Password"))))),
            React.createElement("div", { className: "col-6" },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col" },
                        React.createElement(UserProfileForm, { values: profile_data, profile_svc: profile_svc }))),
                React.createElement("div", { className: "row justify-content-end" },
                    React.createElement("div", { className: "col-4" },
                        React.createElement(buttons_1.BlockButton, { onClick: function () { return profile_svc.save(); } }, gettext("Save"))))),
            React.createElement("div", { className: "col-3 text-center" },
                React.createElement(TwoFactorAuthApp_1.default, null)))));
};
exports.UserProfile = UserProfile;
var UserProfileApp = (function (_super) {
    __extends(UserProfileApp, _super);
    function UserProfileApp() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserProfileApp.prototype.render = function () {
        var user = App_1.store.getMe();
        if (!user)
            return null;
        return React.createElement(exports.UserProfile, { user_id: user.id });
    };
    UserProfileApp = __decorate([
        mobx_react_1.observer
    ], UserProfileApp);
    return UserProfileApp;
}(React.Component));
exports.UserProfileApp = UserProfileApp;
